import { memo } from 'react';
import { TransferItem } from '../item';
import { ITournament, ITransfer } from '@zmedia/bm-soccer-ui/interface';
import {
    CustomSlider,
    Element,
    Icon,
    IconButton,
} from '@zmedia/bm-soccer-ui/components';
import {
    URL_SOCCER_PAGE,
} from '@zmedia/bm-soccer-ui/modules/shared';
import styles from './style.module.scss';
import { ArrayUtils } from '@zmedia/bm-soccer-ui/utils';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';

interface IProps {
    transfers: ITransfer[];
    tournament: ITournament;
}

const SlickButtonFix = ({
    currentSlide,
    slideCount,
    children,
    ...props
}: any) => <span {...props}>{children}</span>;

export function TransferSlider(props: IProps) {
    const { transfers = [], tournament } = props;

    const renderItem = (item: ITransfer, index: number) => {
        return <TransferItem item={item} key={index} />;
    };

    const renderItems = () => {
        return transfers.map((item: ITransfer, index: number) => {
            return renderItem(item, index);
        });
    };

    if (ArrayUtils.isEmpty(transfers)) {
        return null;
    }

    const settings = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        speed: 500,
        autoplaySpeed: 4000,
        draggable: false,
        dots: true,
        nextArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-next']}
                    icon="forward-2"
                    title="Sau"
                ></IconButton>
            </SlickButtonFix>
        ),
        prevArrow: (
            <SlickButtonFix>
                <IconButton
                    className={styles['btn-prev']}
                    icon="back-2"
                    title="Trước"
                ></IconButton>
            </SlickButtonFix>
        ),
    };

    return (
        <Element className={styles['transfer-wrapper']}>
            <TitleWrap
                title="Chuyển nhượng"
                link={`${URL_SOCCER_PAGE.SUBPATH}chuyen-nhuong-${tournament.path}`}
            >
                <Icon icon="forward-2" />
            </TitleWrap>
            <Element className={styles['transfer-slider']}>
                <CustomSlider settings={settings}>{renderItems()}</CustomSlider>
            </Element>
        </Element>
    );
}

export default memo(TransferSlider);
